module.exports = __webpack_public_path__ + "0b39bb509ebc8dab660694f09e2328d3.png";